<template>
  <v-data-table
    :headers="headers"
    :items="content"
    hide-actions
  >
    <template slot="items" slot-scope="props">
      <td class="text-xs-right">{{ props.item.doc_id }}</td>
      <td>
        <div v-if="props.item.name == 'rashodnayanakladnaya'" class="rashodnayanakladnaya-title">
          <v-tooltip right>
            <div slot="activator">
              {{ props.item.doc_title }}
              <v-progress-linear
                color="accent"
                class="rashodnayanakladnaya-status"
                style="margin-top: 0;margin-bottom: 0;"
                height="5"
                :value="statuses[props.item.cond].value"
              />
            </div>
            <span>{{statuses[props.item.cond].tooltip}}</span>
          </v-tooltip>
        </div>
        <template v-else>
          {{ props.item.doc_title }}
        </template>
      </td>
      <td>{{ props.item.created_on }}</td>
      <td class="text-xs-right">
        {{ props.item.summa }}
        <span class="grey--text currency">{{currencies[props.item.valuti_id]}}</span>
      </td>
      <td class="text-xs-left">
        <v-tooltip bottom>
          <v-icon
            class="mr-2"
            slot="activator"
            @click="openDocument(props.item)"
          >
            mdi-pencil
          </v-icon>
          <span>Открыть</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-icon
            v-if="allowDeleteList.indexOf(props.item.name) > - 1"
            class="mr-2"
            slot="activator"
            @click="openCatalog(props.item)"
          >
            mdi-plus
          </v-icon>
          <span>Добавить товар</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-icon
            v-if="allowDeleteList.indexOf(props.item.name) > - 1"
            slot="activator"
            color="red"
            @click="openDeleteConfirmationModal(props.item)"
          >
            mdi-delete
          </v-icon>
          <span>Удалить</span>
        </v-tooltip>
      </td>
    </template>
    <template slot="no-data">
      <empty-table
        :emptyText="'У вас нет документов'"
      />
    </template>
  </v-data-table>
</template>

<script>
import emptyTable from '@/components/helpers/EmptyTable'
export default {
  name: 'DashboardDocumentsTable',
  components: {
    emptyTable
  },
  props: {
    content: {
      default: () => [],
      required: true,
      type: Array
    },
    currencies: {
      default: () => {},
      required: true,
      type: Object
    },
    allowDeleteList: {
      default: () => [],
      required: true,
      type: Array
    },
    statuses: {
      default: () => [],
      required: true,
      type: Array
    }
  },
  data () {
    return {
      headers: [
        {
          text: '№',
          align: 'right',
          width: '100px',
          value: 'doc_id'
        },
        {
          text: 'Документ',
          width: '190px',
          value: 'doc_title'
        },
        {
          text: 'Дата',
          width: '200px',
          value: 'created_on'
        },
        {
          text: 'Сумма',
          width: '120px',
          align: 'right',
          value: 'summa'
        },
        {
          text: '',
          align: 'center',
          width: '145px',
          value: 'actions',
          sortable: false
        }
      ]
    }
  },
  methods: {
    openDeleteConfirmationModal (item) {
      this.$emit('openDeleteConfirmationModal', item)
    },
    openCatalog (item) {
      this.$emit('openCatalog', item)
    },
    openDocument (item) {
      this.$emit('openDocument', item)
    }
  }
}
</script>

<style scoped>

</style>
